'use strict';

import { BaseController } from '../../base/controller';
import { LoginResponse } from '../../auth/loginResponse';
import _ from 'lodash';

export class TwoFactorModalController extends BaseController {
  constructor($scope, $q, $injector, controllerService, loginService, uiModalDeclarationService) {
    'ngInject';
    super({ $scope, $q, $injector, controllerService, loginService, uiModalDeclarationService });

    this.requestId = this.$stateParams.requestId;
    this.accessToken = this.$stateParams.customerToken;
  }

  get respondSuccessfulAuthorized() {
    return (responseData) => {
      this.successfulAuthorized(responseData);
      return responseData;
    };
  }

  $onInit() {
    const { accessToken, requestId } = this;
    this.$log.debug({ accessToken, requestId });

    if (this.isProtected) {
      return this.uiModalDeclarationService.openUrl({
        url: 'app/common/ui/twoFactorModal/twoFactorModal.tpl.html',
        options: {
          keyboard: false,
          backdrop: 'static',
          scope: this.$scope,
          modalClass: 'two-factor-modal'
        }
      }).then(this.respondSuccessfulAuthorized);
    }
    this.successfulAuthorized();
  }

  sendSms() {
    const { email, accessToken, requestId } = this;
    if (email) {
      this.loginService
        .sendTwoFactorSms({ email, accessToken, requestId })
        .then((resp) => {
          this.token = resp.data.token;
          this.smsSent = true;
        }, () => {
          this.error('twofactor.smsnotsent');
        });
    }
  }

  validateSecret(modal) {
    const { loginService, userService, secret, token, email, accessToken, requestId } = this;
    if (secret) {
      this.validationBusy = true;

      return loginService
        .validateSecret({ secret, token, email, accessToken, requestId })
        .then(LoginResponse.loginTo(userService))
        .then(modal.close, () => {
          this.validationBusy = false;
          this.error('twofactor.codeinvalid');
        });
    }
  }

  successfulAuthorized(response) {
    this.resolveTwoFactorData()
      .then(data => {
        if (this.onResolve) {
          this.onResolve({ data, response });
        }
        this.contentVisible = true;
      });
  }

  resolveTwoFactorData() {
    const { $state, $injector, $q } = this;

    const resolve = $state.current.data && $state.current.data.twoFactorResolve;
    if (!resolve) {
      return $q.resolve(null);
    }

    const keys = _.keys(resolve);
    const promises = _.values(resolve).map(r => $injector.invoke(r, null, $state.params));

    // Resolve all promises. When successful, create a response object with resolved values.
    return $q
      .all(promises)
      .then(args => {
        return _.reduce(keys, (acc, k, i) => {
          acc[k] = args[i];
          return acc;
        }, {});
      });
  }
}
